export default __webpack_public_path__ + "static/media/stay-updated.fc89a202.webp";